import React, { Fragment } from 'react';
import { Link } from 'gatsby';
import { nanoid } from 'nanoid';

import { Logo } from './vectors';
import { useGraphQL } from '../hooks';
import { footerNavigation, socialLinks } from '../data';

function Footer() {
  const {
    site: {
      siteMetadata: { title, address, phone, email, hours },
    },
  } = useGraphQL();
  return (
    <footer className="bg-white text-dark-pink">
      <div className="w-full px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:py-16 lg:px-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="xl:col-span-1">
            <div className="flex flex-col space-y-6">
              <Link
                to="/"
                className="flex mx-auto my-auto transition duration-150 ease-in-out focus:shadow-none hover:text-light-pink focus:text-light-pink"
              >
                <div>
                  <span className="sr-only">{title}</span>
                  <Logo className="h-16" />
                </div>
              </Link>
              <div className="flex items-center justify-center space-x-3">
                {socialLinks.map((icon) => (
                  <a
                    key={icon.id}
                    href={icon.url}
                    className="transition duration-150 ease-in-out hover:text-light-pink focus:text-light-pink focus:shadow-none"
                  >
                    <icon.icon className="h-6" />
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-8 mt-12 xl:mt-0 xl:col-span-2">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <ul className="space-y-3">
                  {footerNavigation.column1.map((node) => (
                    <li key={nanoid()}>
                      <Link
                        to={node.slug}
                        className="uppercase transition duration-150 ease-in-out text-dark-pink hover:underline focus:underline focus:shadow-none"
                      >
                        {node.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <ul className="space-y-3">
                  {footerNavigation.column2.map((node) => (
                    <li key={nanoid()}>
                      <Link
                        to={node.slug}
                        className="uppercase transition duration-150 ease-in-out text-dark-pink hover:underline focus:underline focus:shadow-none"
                      >
                        {node.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <div className="flex flex-col space-y-3 text-dark-pink">
                  {hours.map((h) => (
                    <Fragment key={nanoid()}>
                      <div className="uppercase">
                        {h.day} – {h.time}
                      </div>
                    </Fragment>
                  ))}
                </div>
              </div>
              <div className="mt-12 md:mt-0">
                <dl className="ml-auto space-y-3 uppercase text-dark-pink">
                  <dt>
                    <a
                      href={`tel:${phone.split(' ').join('')}`}
                      className="hover:underline focus:underline focus:shadow-none"
                    >
                      {phone}
                    </a>
                  </dt>
                  <dd>
                    <a
                      href={`mailto:${email}`}
                      className="uppercase break-all transition duration-150 ease-in-out text-dark-pink hover:underline focus:underline focus:shadow-none"
                    >
                      {email}
                    </a>
                  </dd>
                  <div>
                    <a
                      href={address.googleMaps}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="uppercase transition duration-150 ease-in-out text-dark-pink hover:underline focus:underline focus:shadow-none"
                    >
                      {address.line1},
                      <br />
                      {address.line2}
                    </a>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-8 mt-12 border-t border-light-pink">
          <p className="tracking-wider text-center uppercase">
            Website by{' '}
            <a
              href="https://www.phirannodesigns.com.au"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold uppercase transition duration-150 ease-in-out text-dark-pink hover:underline focus:underline focus:shadow-none"
            >
              Phiranno Designs
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export { Footer };
